<template>
  <v-main>
    <v-container>
      <v-tabs
        v-model="select"
        slider-size="3"
      >
        <v-tab
          v-for="(tab, idx) in tabs"
          :key="idx"
          :exact="idx===0"
          :to="{ name: 'Post', params: { type: tab.type } }"
          class="font-weight-black"
        >{{ tab.text }}</v-tab>
      </v-tabs>

      <v-select
        v-model="cat"
        :items="['職場簡報','客服禮儀','大數據','智能AI','其他']"
        label="類別篩選"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        outlined
        clearable
        class="mt-7"
        style="max-width:200px !important;"
      ></v-select>

      <v-divider class="my-4"></v-divider>

      <div>
        <article-previewing
          v-for="(article, idx) in articlesFilter"
          :key="idx"
          :article="article"
          :index="idx"
        ></article-previewing>
      </div>
        
      <infinite-loading
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <template #spinner>
          <app-load></app-load>
        </template>
        <template #no-more>
          <v-divider class="my-4"></v-divider>
          <small>已經到底囉 :)</small>
        </template>
        <template #no-results>目前還沒有文章喔</template>
        <template #error="{ trigger }">
          <div class="d-flex flex-column justify-center align-center">
            <span>發生錯誤</span>
            <v-btn
              color="primary"
              @click="trigger"
              class="mt-2"
            >重新載入</v-btn>
          </div>
        </template>
      </infinite-loading>
    </v-container>
  </v-main>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import apiArticle from '@/assets/js/db/api/article';

export default {
  props: ['type'],
  components: {
    InfiniteLoading,
    'article-previewing': () => import('@/components/article/previewing'),
    'app-load': () => import('../components/app/load')
  },
  data: () => ({
    cat: null,
    select: 0,
    tabs: [
      { text: '全部', type: null },
      { text: '精彩回顧', type: '精彩回顧' },
      { text: '課程資訊', type: '課程資訊' },
      { text: '職場技能', type: '職場技能' }
    ],
    articles: [],
    page: 1,
    infiniteId: +new Date(),
  }),
  computed: {
    articlesFilter() {
      return this.articles.filter(el => {
        return !this.cat ? true : this.cat===el.cat;
      });
    }
  },
  watch:{
    $route() {
      this.initPage();
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    infiniteHandler($state) {
      const params = {
        ...this.$route.params,
        page: this.page
      };
      apiArticle.getList(params)
        .then(({ data }) => {
          if (data.length) {
            this.page += 1;
            this.articles.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async initPage() {
      this.page = 1;
      this.articles = [];
      this.infiniteId += 1;
    }
  }
}
</script>